// URL de base de l'API backend.
// En développement : http://localhost:8000 (défaut)
// En production  : défini dans .env.production via REACT_APP_API_URL
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

export default API_URL;
